import { render, staticRenderFns } from "./DsTable.vue?vue&type=template&id=3fd64350&"
import script from "./DsTable.vue?vue&type=script&lang=js&"
export * from "./DsTable.vue?vue&type=script&lang=js&"
import style0 from "./DsTable.vue?vue&type=style&index=0&id=3fd64350&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports